import Vue from 'vue/dist/vue.min';
//import {modal} from './components/modal';

document.addEventListener('DOMContentLoaded', function() {
    const v = new Vue({
        el: '#site-recipe',
		data: {
			src: '',
			show: false,
			aspect: 'horizontal',
		},
		methods: {
			video: function(url){
				if(window.innerWidth > window.innerHeight){
					this.aspect = 'horizontal';

				}else{
					this.aspect = 'vertical';
				}
				this.show = true;
				this.src = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + url +'?autoplay=1&mute=1&playsinline=1&loop=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
			}
		}
    });
});